import app from 'flarum/forum/app';
import Page, { IPageAttrs } from 'flarum/common/components/Page';
import ItemList from 'flarum/common/utils/ItemList';
import SubscribeCard from '../Groups/SubscribeCard';
import type Group from 'flarum/common/models/Group';
import type Mithril from 'mithril';
import { ApiPayloadPlural, ApiResponse } from 'flarum/common/Store';
import Product from '../../common/Product';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

export default class AccessPortal extends Page {
  private groups: Group[] = [];
  protected bodyClass = 'access-portal';
  protected loading: boolean = false;

  oninit(vnode: Mithril.Vnode<IPageAttrs, this>) {
    super.oninit(vnode);

    this.loading = true;

    this.loadProducts();
  }

  view() {
    return <div className="AccessPortal container">{this.loading ? <LoadingIndicator /> : this.groupItems().toArray()}</div>;
  }

  loadProducts() {
    const preloadedProducts = app.preloadedApiDocument();

    if (preloadedProducts) {
      // We must wrap this in a setTimeout because if we are mounting this
      // component for the first time on page load, then any calls to m.redraw
      // will be ineffective and thus any configs (scroll code) will be run
      // before stuff is drawn to the page.
      // @ts-ignore
      setTimeout(this.show.bind(this, preloadedProducts), 0);
    } else {
      app
        .request<ApiPayloadPlural>({
          url: app.forum.attribute('apiUrl') + '/blomstra-payments/stripe/products?for=pta',
          method: 'GET',
        })
        .then(this.show.bind(this));
    }
  }

  show(response: ApiPayloadPlural) {
    // Filter out all groups that have a pta product set.
    const groups = app.store.all<Group>('groups').filter((group) => group.blomstraPtaProduct());

    const products = (response.data || []) as unknown as Product[];

    // Assign the pta product to the group.
    groups.map((group) => {
      group.product = products.find((product) => product.id === group.blomstraPtaProduct());
    });

    // Assign groups that have a matching product.
    this.groups = groups.filter((group) => group?.product);

    this.loading = false;

    m.redraw();
  }

  groupItems() {
    const items = new ItemList();

    this.groups.forEach((group) => items.add(group.namePlural(), <SubscribeCard group={group} />));

    return items;
  }
}
